import { nanoid } from '@reduxjs/toolkit';

const id = nanoid();

export default function ArrowDownLeft({ color = '#000000', ...props }: Record<string, unknown> & { color?: string }) {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>arrow-down-left</title>
      <defs>
        <path
          d="M12.2928932,0.292893219 C12.6834175,-0.0976310729 13.3165825,-0.0976310729 13.7071068,0.292893219 C14.0976311,0.683417511 14.0976311,1.31658249 13.7071068,1.70710678 L3.414,12 L10,12 C10.5128358,12 10.9355072,12.3860402 10.9932723,12.8833789 L11,13 C11,13.5522847 10.5522847,14 10,14 L1,14 C0.988873384,14 0.977789211,13.9998183 0.966750287,13.9994576 C0.949733631,13.9989053 0.931734513,13.9978436 0.913769205,13.9962979 C0.892113954,13.9944666 0.871475338,13.9920328 0.851038784,13.9889807 C0.83405099,13.9863719 0.816624737,13.9832978 0.799274239,13.9797599 C0.777253921,13.9753602 0.755563524,13.9701664 0.734160388,13.964279 C0.718536724,13.9599023 0.703148659,13.9552713 0.687857476,13.9502619 C0.668202324,13.9438775 0.648420797,13.9366843 0.628941476,13.928896 C0.611204351,13.9218036 0.593901505,13.914321 0.576778453,13.9063266 C0.556108604,13.8966234 0.535706055,13.8862061 0.515723049,13.8751242 C0.503605559,13.8685012 0.491386894,13.8613931 0.479291247,13.8540045 C0.453725048,13.8382813 0.428869307,13.8215099 0.404840697,13.8036865 C0.365674419,13.774687 0.328287271,13.7425008 0.292893219,13.7071068 L0.383249919,13.787214 C0.319818245,13.7374483 0.262551711,13.6801818 0.212785965,13.6167501 C0.207284482,13.6098424 0.201753444,13.602603 0.196334578,13.5953066 C0.178490093,13.5711307 0.1617187,13.546275 0.146067433,13.5206602 C0.138606922,13.5086131 0.131498828,13.4963944 0.124671174,13.4840621 C0.11379392,13.4642939 0.103376643,13.4438914 0.0936537803,13.4230991 C0.0856790475,13.4060985 0.0781964242,13.3887956 0.0712254916,13.371336 C0.0633157362,13.3515792 0.0561224864,13.3317977 0.0495466818,13.3117364 C0.0447287157,13.2968513 0.0400977346,13.2814633 0.0358451423,13.265993 C0.0298336259,13.2444365 0.0246397952,13.2227461 0.0201651536,13.2007941 C0.0167021706,13.1833753 0.0136280806,13.165949 0.0110178009,13.1484669 C0.00376118706,13.1003621 0,13.0506203 0,13 L0.00396640833,13.0892501 C0.00189498016,13.0659949 0.000634893312,13.042681 0.000186147798,13.0193545 L0,13 L0,4 C0,3.44771525 0.44771525,3 1,3 C1.55228475,3 2,3.44771525 2,4 L2,10.584 Z"
          id={id}
        />
      </defs>
      <g id="🕹-Icons" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g id="Feather" transform="translate(-545, -602)">
          <g id="arrow-down-left" transform="translate(550, 607)">
            <mask id={`mask-${id}`} fill="white">
              <use xlinkHref={`#${id}`} />
            </mask>
            <use id="Combined-Shape" fill={color} fillRule="nonzero" xlinkHref={`#${id}`} />
            <g id="COLOR/-black" mask={`url(#mask-${id})`} fill={color}>
              <g transform="translate(-5, -5)" id="Rectangle">
                <rect x={0} y={0} width={24} height={24} />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
